import { useState } from "react";
import { Menu, X, ShoppingBag } from "lucide-react";
import Logo from "@/components/Logo";

const LINKS = [
  { label: "Books", href: "#books" },
  { label: "About Wendy", href: "#about" },
  { label: "Newsletter", href: "#newsletter" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-white/80 border-b-2 border-[#073B4C]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <Logo />

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="font-heading font-medium text-[#073B4C] hover:text-[#EF476F] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#books"
            data-testid="shop-now-btn"
            className="inline-flex items-center gap-2 font-heading font-semibold bg-[#FFD166] text-[#073B4C] border-2 border-[#073B4C] rounded-full px-5 py-2.5 shadow-pop hover:-translate-y-1 hover:rotate-2 transition-transform"
          >
            <ShoppingBag size={18} strokeWidth={2.5} />
            Shop Now
          </a>
        </nav>

        <button
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 border-2 border-[#073B4C] rounded-xl bg-white shadow-pop"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t-2 border-[#073B4C] bg-white px-5 py-5 flex flex-col gap-4"
        >
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="font-heading font-medium text-lg text-[#073B4C]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#books"
            onClick={() => setOpen(false)}
            className="inline-flex items-center justify-center gap-2 font-heading font-semibold bg-[#FFD166] text-[#073B4C] border-2 border-[#073B4C] rounded-full px-5 py-3 shadow-pop"
          >
            <ShoppingBag size={18} strokeWidth={2.5} /> Shop Now
          </a>
        </div>
      )}
    </header>
  );
}
